import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { AmsFile } from '@core/objects/ams-file';
import { AmsFilesListItemMenuClick } from '../files-list-item-menu-click';

/**
 * component for each item of files list either with or without notes counter.
 */
@Component({
    selector: 'core-files-list-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss']
})
export class FilesListItemComponent implements OnInit {

    private _notesCount: number;
    hasNotesCount: boolean = false;

    @Input() file: AmsFile;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    @Input() set notesCount(value: number) {
        this._notesCount = value;
        this.hasNotesCount = value !== null && value !== undefined;
    }

    get notesCount(): number {
        return this._notesCount;
    }
    @Input() displayed: boolean = false;
    
    @Output() actionClick= new EventEmitter<AmsFile>();
    @Output() menuClick = new EventEmitter<AmsFilesListItemMenuClick>();
    @Output() iconDownloadClick = new EventEmitter<AmsFile>();

    constructor() { }

    ngOnInit() {

        
        // this.mainText = "<span class=\"name\">" + this.file.name +"</span> <span class=\"file-size\">(" + this.file.filesize + ")</span>";

        // if(!this.download)
        //     this.downloadText = "";
    }

    actionClickFile(file: AmsFile, event: any){
        this.actionClick.emit(file);
        event.stopPropagation();
    }

    actionDownloadClick(file: AmsFile, event: any){
        this.iconDownloadClick.emit(file);
        event.stopPropagation();
    }

    onMenuSelect(key: string) {
        this.menuClick.emit({key: key, file: this.file});
    }

    protected humanFileSize(size: number): string {
        var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
        return +(size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    }

    getFileExtension(filename: string): string {
        if (!filename || !filename.includes('.')) {
            return '';
        }
        return filename.split('.').pop() || '';
    }
}
